export function isBrowser(){
  return (typeof document !== 'undefined' && typeof window !== 'undefined');
}
export function isServer(){
  return !isBrowser();
}
